// @ts-check
import useWizardState from './useWizardState/useWizardState';
import Icon from 'components/base/Icon';
import WizardMenu from 'components/WizardMenu';
import useWizardMenus from './menus/useWizardMenus';
import {
  onClickEditIdx,
  openWizard
} from './useWizardState/wizard.state.actions';
import SelectedValuesView from './SelectedValuesView/SelectedValuesView';
import _ from 'lodash';
import { LBButton } from '@linearb/buzz';

const AzureBoardsTeamsAreasSelector = ({
  multipleEnabled = false,
  defaultSelectedValues = [],
  onChange = _.noop
}) => {
  const wizardState = useWizardState({ defaultSelectedValues, onChange });
  const { openMenus, menuRef } = useWizardMenus(wizardState);

  const isSelectedValuesEmpty = wizardState.selectedValues.length === 0;
  const isEditMode =
    wizardState.isEditMode || (!isSelectedValuesEmpty && !multipleEnabled);

  return (
    <div>
      <SelectedValuesView
        selectedValues={wizardState.selectedValues}
        multipleEnabled={multipleEnabled}
        dispatch={wizardState.dispatch}
      />

      <LBButton
        ref={menuRef}
        onClick={() =>
          isEditMode
            ? wizardState.dispatch(onClickEditIdx(0))
            : wizardState.dispatch(openWizard())
        }
      >
        <Icon color='catskillWhite' name={isEditMode ? 'Pencil' : 'Add'} />
        {isEditMode ? 'Edit' : 'Add'} filter
      </LBButton>

      {openMenus.map((menu, idx) => (
        <WizardMenu
          key={idx}
          menu={menu}
          level={idx}
          anchorEl={menuRef.current}
        />
      ))}
    </div>
  );
};

export default AzureBoardsTeamsAreasSelector;
